module.exports = __webpack_public_path__ + "img/daifafang.a2143da9.svg";